import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'laverana',
} as IModuleProps;
